module.exports = __webpack_public_path__ + "static/Karolina_Osickova_AmazingGrace-41f8b3305e4ceef4c22295de6d861111.mp3";